<template>
  <layout-desktop-wrapper>
    <notifications :padding="'16px'"/>
  </layout-desktop-wrapper>
</template>

<script lang="ts" setup>
import LayoutDesktopWrapper from '@app/components/layout/LayoutDesktopWrapper.vue';
import { Notifications } from '@pidz/shared/components';
</script>